"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../CTAs/Button"));

var _useKeyDown = _interopRequireDefault(require("../utils/useKeyDown"));

var _excluded = ["ariaLabel", "backdrop", "children", "classes", "closeAriaLabel", "closeMethod", "dataTestId", "id", "isFullWidth", "isModalTitleStatic", "isOpen", "modalCTAs", "modalTitle"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Modal = function Modal(_ref) {
  var ariaLabel = _ref.ariaLabel,
      backdrop = _ref.backdrop,
      children = _ref.children,
      classes = _ref.classes,
      closeAriaLabel = _ref.closeAriaLabel,
      closeMethod = _ref.closeMethod,
      dataTestId = _ref.dataTestId,
      id = _ref.id,
      isFullWidth = _ref.isFullWidth,
      isModalTitleStatic = _ref.isModalTitleStatic,
      isOpen = _ref.isOpen,
      modalCTAs = _ref.modalCTAs,
      modalTitle = _ref.modalTitle,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  // State hooks for modal opening and closing
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenLocalState = _useState2[0],
      setIsOpenLocalState = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isClosing = _useState4[0],
      setIsClosing = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentScrollY = _useState6[0],
      setCurrentScrollY = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMobileDevice = _useState8[0],
      setIsMobileDevice = _useState8[1];

  var _useState9 = (0, _react.useState)(document.activeElement),
      _useState10 = _slicedToArray(_useState9, 2),
      triggerElement = _useState10[0],
      setTriggerElement = _useState10[1]; // State hooks for modal element scrolling


  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      modalELIsScrolled = _useState12[0],
      setModalElIsScrolled = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isModalTitleVisible = _useState14[0],
      setModalTitleVisible = _useState14[1];

  var _useState15 = (0, _react.useState)(0),
      _useState16 = _slicedToArray(_useState15, 2),
      dynamicModalTitleScrollThreshold = _useState16[0],
      setDynamicModalTitleScrollThreshold = _useState16[1]; // Refs for modal elements


  var modalEl = (0, _react.useRef)(null);
  var modalBodyEl = (0, _react.useRef)(null);
  var modalPortalEl = (0, _react.useRef)(null); // CSS class abstractions

  var modalPortalElClass = 'modal__backdrop';
  var documentBodyClass = 'modal--is-open';

  function openModal() {
    setCurrentScrollY(window.scrollY);
    setIsOpenLocalState(true);
    document.body.style.top = "-".concat(window.scrollY, "px");
    document.body.classList.add(documentBodyClass);
    document.body.appendChild(modalPortalEl.current); // Preserves scroll bar area, if there is one before the modal opens
    // to prevent body content under modal from jumping on open/close

    if (document.body.clientHeight > window.innerHeight) {
      document.body.style.overflowY = 'scroll';
    }
  }

  function closeModal() {
    setIsClosing(true);
    document.body.classList.add('modal--is-closing');

    modalEl.current.onanimationend = function () {
      setIsOpenLocalState(false);
      setIsClosing(false);
      document.body.classList.remove(documentBodyClass);
      document.body.classList.remove('modal--is-closing');
      document.body.removeAttribute('style');
      document.body.removeChild(modalPortalEl.current); // Instantly scroll user to where they were when modal opened

      window.scrollTo({
        top: currentScrollY,
        behavior: 'instant'
      });
      closeMethod();
    };
  }

  function getScrollThresholdAmount(el) {
    return el.clientHeight < 100 ? el.clientHeight : 100;
  }

  function handleModalScroll() {
    var scrollAmount = modalBodyEl.current.scrollTop; // updates value onScroll

    if (scrollAmount === 0) {
      setModalElIsScrolled(false);
    }

    if (scrollAmount > 0) {
      setModalElIsScrolled(true);
    }

    if (!isModalTitleStatic) {
      if (scrollAmount > dynamicModalTitleScrollThreshold) {
        setModalTitleVisible(true);
      }

      if (scrollAmount < dynamicModalTitleScrollThreshold) {
        setModalTitleVisible(false);
      }
    }
  }

  var focusTrap = function focusTrap(event) {
    var _modalEl$current, _modalEl$current2;

    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    var firstFocusableElement = modalEl === null || modalEl === void 0 ? void 0 : (_modalEl$current = modalEl.current) === null || _modalEl$current === void 0 ? void 0 : _modalEl$current.querySelectorAll(focusableElements)[0];
    var focusableContent = modalEl === null || modalEl === void 0 ? void 0 : (_modalEl$current2 = modalEl.current) === null || _modalEl$current2 === void 0 ? void 0 : _modalEl$current2.querySelectorAll(focusableElements);
    var lastFocusableElement = focusableContent && focusableContent[focusableContent.length - 1];
    var isTabPressed = event.key === 'Tab' || event.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        event.preventDefault();
      }
    } else if (document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      event.preventDefault();
    }
  };

  (0, _react.useEffect)(function () {
    modalPortalEl.current = document.createElement('div');
    modalPortalEl.current.classList.add(modalPortalElClass);
    modalPortalEl.current.setAttribute('role', 'presentation'); // cleanup modalPortalEl from DOM if modal is destroyed in an unexpected way

    return function () {
      modalPortalEl.current.remove();
      document.body.classList.remove(documentBodyClass);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isOpen && !isOpenLocalState) {
      openModal();
    }

    if (!isOpen && isOpenLocalState) {
      closeModal();
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    if (id) {
      modalPortalEl.current.setAttribute('id', id);
    } else {
      modalPortalEl.current.removeAttribute('id');
    }
  }, [id]);
  (0, _react.useEffect)(function () {
    if (dataTestId) {
      modalPortalEl.current.setAttribute('data-testid', dataTestId);
    } else {
      modalPortalEl.current.removeAttribute('data-testid');
    }
  }, [dataTestId]); // TODO: navigator.platform is deprecated, however the replacement, navigator.userAgentData.platform, is not yet widely supported. We'll want to keep an eye on this and make the update when support has improved.
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform - MR, 1/22

  (0, _react.useEffect)(function () {
    var _classNames;

    setIsMobileDevice(/Android|webOS|iPhone|iPod|BlackBerry/i.test(window.navigator.platform));
    var modalBackdropElClasses = (0, _classnames.default)(modalPortalElClass, (_classNames = {}, _defineProperty(_classNames, "modal__backdrop--".concat(backdrop), backdrop), _defineProperty(_classNames, 'modal__backdrop--bottom-padded', isMobileDevice), _classNames), classes);
    modalPortalEl.current.className = modalBackdropElClasses;
  }, [backdrop, classes, isMobileDevice]);
  (0, _useKeyDown.default)('Escape', function () {
    return modalEl.current && closeModal();
  });
  (0, _react.useEffect)(function () {
    if (isOpenLocalState) {
      setDynamicModalTitleScrollThreshold(getScrollThresholdAmount(modalBodyEl.current.children[0]));
    }
  }, [isOpenLocalState]); // Focus trap

  (0, _react.useEffect)(function () {
    setTriggerElement(document.activeElement);

    if (isOpenLocalState) {
      document.addEventListener('keydown', function (event) {
        return focusTrap(event);
      });
      modalBodyEl.current.focus();
    } else {
      triggerElement.focus();
    }

    return function () {
      document.removeEventListener('keydown', function (event) {
        return focusTrap(event);
      });
    };
  }, [isOpenLocalState]);

  if (isOpenLocalState) {
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("section", _extends({
      className: (0, _classnames.default)('modal__element', {
        'modal__element--full-width': isFullWidth,
        'modal__element--is-scrolled': modalELIsScrolled,
        'modal__element--is-closing': isClosing
      }),
      role: "dialog",
      "aria-label": ariaLabel || modalTitle,
      ref: modalEl
    }, additionalProps), /*#__PURE__*/_react.default.createElement("header", {
      className: (0, _classnames.default)('modal-header', {
        'modal-header--with-title': modalTitle
      })
    }, modalTitle && /*#__PURE__*/_react.default.createElement("h2", {
      className: (0, _classnames.default)('modal-title', {
        'modal-title--is-static': isModalTitleStatic
      }, {
        'modal-title--is-visible': isModalTitleVisible
      })
    }, modalTitle), /*#__PURE__*/_react.default.createElement(_Button.default, {
      icon: "IconClose",
      text: "",
      ariaLabel: closeAriaLabel,
      classes: "modal-close",
      variant: "text-alternate",
      dataTestId: "modalClose",
      size: "medium",
      clickMethod: function clickMethod() {
        return closeModal();
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      onScroll: function onScroll() {
        return handleModalScroll();
      },
      className: "modal__body",
      ref: modalBodyEl,
      tabIndex: "-1",
      "data-testid": "modalBody"
    }, children), modalCTAs && /*#__PURE__*/_react.default.createElement("footer", {
      className: "modal-footer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-footer__cta-wrapper"
    }, modalCTAs))), modalPortalEl.current);
  }

  return null;
};

Modal.propTypes = {
  /**
   Optional. Required if no modalTitle is provided. Sets the aria-label attribute for the modal element.
   */
  ariaLabel: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    return props.modalTitle === '';
  }),

  /**
   Optional. Sets the backdrop color. Defaults to `"dark"`.
   */
  backdrop: _propTypes.default.oneOf(['light', 'dark']),

  /**
   Required. The contents of the modal element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. String to add custom class(es) to the component. Defaults to `null`.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Allows the close button to accept custom aria-label. Defaults to `"Close modal"`.
   */
  closeAriaLabel: _propTypes.default.string,

  /**
   Required. The function passed to all of the component's close triggers.
   */
  closeMethod: _propTypes.default.func.isRequired,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element's `id` attribute. Defaults to `null`.
   */
  id: _propTypes.default.string,

  /**
   Optional. Allows the modal to extends to the full-width of the screen. Defaults to `false`.
   */
  isFullWidth: _propTypes.default.bool,

  /**
   Optional. If false, it shows no title in the header on load, but shows it once the user scrolls the modal body. If true, the title will always show in the header. Defaults to `false`.
   */
  isModalTitleStatic: _propTypes.default.bool,

  /**
   Optional, but required to toggle the modal between open and closed. Defaults to `false`.
   */
  isOpen: _propTypes.default.bool,

  /**
   Optional. The JSX for any CTAs that should display in the modal footer. Defaults to `null`.
   */
  modalCTAs: _propTypes.default.node,

  /**
   Optional. The text content that shows in the modal header. Defaults to `''`.
   */
  modalTitle: _propTypes.default.string
};
Modal.defaultProps = {
  ariaLabel: 'Please add an aria-label',
  backdrop: 'dark',
  classes: '',
  closeAriaLabel: 'Close modal',
  dataTestId: null,
  id: null,
  isFullWidth: false,
  isModalTitleStatic: false,
  isOpen: false,
  modalTitle: '',
  modalCTAs: null
};
var _default = Modal;
exports.default = _default;